import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Calendar, Search, UserCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import SearchBar from './SearchBar';
import defaultAvatar from '../assets/default-avatar.jpg';

function FooterPWA() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated } = useAuth();
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [isPWA, setIsPWA] = useState(false);

  // Détecter si l'app est en mode PWA
  useEffect(() => {
    const checkPWA = () => {
      // Vérifier si l'app est en mode standalone (PWA installée)
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches
        || window.navigator.standalone
        || document.referrer.includes('android-app://');

      setIsPWA(isStandalone);
    };

    checkPWA();
  }, []);

  // Ne pas afficher le footer si pas en PWA ou pas authentifié
  if (!isPWA || !isAuthenticated) {
    return null;
  }

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Footer sticky */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-slate-900 border-t border-slate-800 z-50 safe-area-bottom">
        <div className="flex items-center justify-around px-4 py-3">
          {/* Calendrier */}
          <button
            onClick={() => navigate('/calendar')}
            className={`flex flex-col items-center justify-center min-w-[60px] transition-all ${
              isActive('/calendar')
                ? 'text-indigo-500'
                : 'text-gray-400 hover:text-gray-300'
            }`}
          >
            <Calendar size={24} className={isActive('/calendar') ? 'scale-110' : ''} />
            <span className="text-[10px] mt-1 font-medium">Calendrier</span>
          </button>

          {/* Search */}
          <button
            onClick={() => setShowSearchModal(true)}
            className="flex flex-col items-center justify-center min-w-[60px] text-gray-400 hover:text-gray-300 transition-all"
          >
            <Search size={24} />
            <span className="text-[10px] mt-1 font-medium">Recherche</span>
          </button>

          {/* Profil */}
          <button
            onClick={() => navigate('/profile')}
            className={`flex flex-col items-center justify-center min-w-[60px] transition-all ${
              isActive('/profile')
                ? 'text-indigo-500'
                : 'text-gray-400 hover:text-gray-300'
            }`}
          >
            {user?.photoProfil ? (
              <img
                src={user.photoProfil}
                alt="Profile"
                className={`w-6 h-6 rounded-full object-cover border-2 ${
                  isActive('/profile')
                    ? 'border-indigo-500'
                    : 'border-gray-600'
                }`}
              />
            ) : (
              <img
                src={defaultAvatar}
                alt="Profile"
                className={`w-6 h-6 rounded-full object-cover border-2 ${
                  isActive('/profile')
                    ? 'border-indigo-500'
                    : 'border-gray-600'
                }`}
              />
            )}
            <span className="text-[10px] mt-1 font-medium">Profil</span>
          </button>
        </div>
      </div>

      {/* Modal de recherche */}
      {showSearchModal && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[60] flex items-start justify-center p-4 pt-20">
          <div className="w-full max-w-2xl">
            <div className="mb-4">
              <SearchBar onSearch={() => setShowSearchModal(false)} />
            </div>
            <button
              onClick={() => setShowSearchModal(false)}
              className="w-full py-3 bg-slate-800 hover:bg-slate-700 text-white rounded-lg font-semibold transition"
            >
              Fermer
            </button>
          </div>
        </div>
      )}

      {/* Spacer pour éviter que le contenu soit caché derrière le footer */}
      <div className="md:hidden h-20"></div>
    </>
  );
}

export default FooterPWA;
